import ApiRoutes from "../../../constants/api-routes";
import { hneInsightApi, hneAdminApi } from "../../../service";

export const addNewJobImpression = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_NEW_JOBS_IMPRESSION}`, body);

export const addNewGazetteImpression = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_NEW_GAZETTE_IMPRESSION}`, body);

export const addNewJobsDownloadImpression = async (body) =>
  hneInsightApi.post(`${ApiRoutes.CREATE_NEW_JOBS_IMPRESSION_DOWNLOAD}`, body);

export const addJobComment = async (body, job_id) =>
  hneAdminApi.post(`${ApiRoutes.ADD_JOB_COMMENT}?job_id=${job_id}`, body);

export const changeJobCommentLike = async (action, comment_id, job_id) =>
  hneAdminApi.post(
    `${ApiRoutes.CHANGE_JOB_COMMENT_LIKE}?action=${action}&comment_id=${comment_id}&job_id=${job_id}`
  );

export const updateJobCommentStatus = async (status, comment_id, job_id) =>
  hneAdminApi.put(
    `${ApiRoutes.UPDATE_JOB_COMMENT_STATUS}?status=${status}&comment_id=${comment_id}&job_id=${job_id}`
  );

export const deleteJobComment = async (comment_id, job_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_JOB_COMMENT}/${comment_id}/${job_id}`);
